import { Icon } from '@chakra-ui/icons'

// Checkmark SVG Component
const CheckMark = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M3 8.50012L6 11.5001L13 4.50012"
            stroke={color}
            strokeWidth="2"
        />
    </svg>
)

// Divider SVG Component
const Divider = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="24"
        viewBox="0 0 8 24"
        fill="none"
    >
        <path
            d="M7 -1L1 25"
            stroke={color}
            strokeOpacity="0.5"
            strokeWidth="1"
        />
    </svg>
)

const SrBrownBelt = props => (
    <Icon viewBox="0 0 220 220" fill="none" {...props}>
        <path
            d="M145.127 195.149L148.155 202.451M149.437 192.334L154.14 195.006M139.748 197.037L138.608 202.131"
            stroke="#333333"
            strokeWidth="2"
        />
        <path
            d="M151.943 158.004L159.149 133.982H47.1491L39.9427 158.004H151.943Z"
            fill="#191919"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M78.3438 30H190.344L180.744 62H68.7438L78.3438 30ZM61.5438 86L47.1491 133.982H159.149L173.544 86H61.5438ZM39.9427 158.004H151.943L142.344 190H30.3438L39.9427 158.004Z"
            fill="#B98840"
        />
        <path
            d="M180.744 62H68.7438L61.5438 86H173.544L180.744 62Z"
            fill="#191919"
        />
        <path
            d="M79.3429 23.3492C79.807 25.1573 80.5766 26.7846 81.5764 28.1205C82.684 29.6004 84.0839 30.7329 85.6677 31.3418C84.0843 31.9486 82.6844 33.0773 81.5768 34.5537C80.5768 35.8866 79.807 37.511 79.3429 39.3172C78.8775 37.5107 78.1058 35.8863 77.1046 34.5535C75.9958 33.0774 74.5955 31.9487 73.0142 31.3418C74.5959 30.7328 75.9962 29.6003 77.1049 28.1208C78.1059 26.7849 78.8775 25.1575 79.3429 23.3492Z"
            stroke="#323330"
        />
        <path
            d="M86.6868 38.3284C86.9504 39.0784 87.3109 39.761 87.75 40.3477C88.2774 41.0525 88.9252 41.6259 89.6582 42.0038C88.9255 42.3805 88.2778 42.952 87.7503 43.6552C87.3111 44.2406 86.9505 44.9221 86.6868 45.6712C86.4224 44.9219 86.061 44.2404 85.6212 43.6549C85.0932 42.952 84.4453 42.3805 83.7132 42.0038C84.4456 41.6258 85.0936 41.0525 85.6215 40.3479C86.0611 39.7613 86.4224 39.0786 86.6868 38.3284Z"
            stroke="#323330"
        />
    </Icon>
)

const SrRedBelt = props => (
    <Icon viewBox="0 0 220 220" fill="none" {...props}>
        <path
            d="M145.127 195.149L148.155 202.451M149.437 192.334L154.14 195.006M139.748 197.037L138.608 202.131"
            stroke="#333333"
            strokeWidth="2"
        />
        <path
            d="M151.943 158.004L159.149 133.982H47.1491L39.9427 158.004H151.943Z"
            fill="#191919"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M78.3438 30H190.344L180.744 62H68.7438L78.3438 30ZM61.5438 86L47.1491 133.982H159.149L173.544 86H61.5438ZM39.9427 158.004H151.943L142.344 190H30.3438L39.9427 158.004Z"
            fill="#EF3837"
        />
        <path
            d="M180.744 62H68.7438L61.5438 86H173.544L180.744 62Z"
            fill="#191919"
        />
        <path
            d="M79.3429 23.3492C79.807 25.1573 80.5766 26.7846 81.5764 28.1205C82.684 29.6004 84.0839 30.7329 85.6677 31.3418C84.0843 31.9486 82.6844 33.0773 81.5768 34.5537C80.5768 35.8866 79.807 37.511 79.3429 39.3172C78.8775 37.5107 78.1058 35.8863 77.1046 34.5535C75.9958 33.0774 74.5955 31.9487 73.0142 31.3418C74.5959 30.7328 75.9962 29.6003 77.1049 28.1208C78.1059 26.7849 78.8775 25.1575 79.3429 23.3492Z"
            stroke="#323330"
        />
        <path
            d="M86.6868 38.3284C86.9504 39.0784 87.3109 39.761 87.75 40.3477C88.2774 41.0525 88.9252 41.6259 89.6582 42.0038C88.9255 42.3805 88.2778 42.952 87.7503 43.6552C87.3111 44.2406 86.9505 44.9221 86.6868 45.6712C86.4224 44.9219 86.061 44.2404 85.6212 43.6549C85.0932 42.952 84.4453 42.3805 83.7132 42.0038C84.4456 41.6258 85.0936 41.0525 85.6215 40.3479C86.0611 39.7613 86.4224 39.0786 86.6868 38.3284Z"
            stroke="#323330"
        />
    </Icon>
)

const HourGlassRed = props => (
    <Icon viewBox="0 0 62 88" fill="none" {...props}>
        <path
            d="M10.9497 23.3374C10.5723 21.531 10.375 19.6651 10.375 17.7621V13.1484H51.6164V17.7641C51.6164 21.6889 50.777 25.4555 49.2499 28.8698M49.2583 28.8698C50.7863 25.4564 51.625 21.6889 51.625 17.765V13.1484H31M10.9752 64.84C12.9396 55.718 19.5015 48.1325 28.4219 44.9504V43.3933C19.4581 40.1863 12.8782 32.5354 10.9594 23.3455M51.008 64.8398C49.047 55.7215 42.4919 48.1374 33.5781 44.9504V43.4003C38.5259 41.6319 42.748 38.5114 45.8603 34.5242C47.213 32.7917 48.3559 30.8959 49.2583 28.8781M51.008 64.8481C51.4067 66.7026 51.6164 68.6225 51.6164 70.5801V75.2036M10.9834 64.8481C10.5847 66.7044 10.375 68.6259 10.375 70.5853V75.2036H51.6164M51.6164 75.2036L31 75.2042"
            stroke="#787878"
            strokeWidth="2.2"
        />
        <path
            d="M10.375 12.9766V17.5902C10.375 19.4932 10.5723 21.3591 10.9497 23.1655L31.6973 32.4191L49.2499 28.698C50.777 25.2837 51.6164 21.517 51.6164 17.5923V12.9766H10.375Z"
            fill="#F5F9FB"
        />
        <path
            d="M51.625 12.9766V17.5931C51.625 21.517 50.7863 25.2845 49.2583 28.698L31.7064 32.4191L31 32.1045V12.9766H51.625Z"
            fill="#EBF3F7"
        />
        <path
            d="M51.0007 64.6678C48.8551 54.6937 41.2133 46.5553 31.0009 44L30.9828 44.0045C20.7688 46.557 13.1245 54.6941 10.9766 64.6681L30.9923 66.6875L51.0007 64.6678Z"
            fill="#F5F9FB"
        />
        <path
            d="M51.008 64.668L31 66.6875V44.0034L31.0086 44C41.2214 46.5558 48.863 54.6941 51.008 64.668Z"
            fill="#EBF3F7"
        />
        <g clipPath="url(#clip0_156787_129605)">
            <path
                d="M51.008 64.6765H39.5938C37.1942 62.2769 35.5473 60.63 33.5781 58.6609V43.2287C38.5259 41.4603 42.748 38.3397 45.8603 34.3526C47.213 32.6201 48.3559 30.7243 49.2583 28.7065C34.0181 28.4091 28.085 23.4677 10.9594 23.1738C12.8782 32.3638 19.4581 40.0147 28.4219 43.2217V58.6609L22.4062 64.6765H10.9834C10.5847 66.5327 10.375 68.4543 10.375 70.4137V75.032H51.6164V70.4085C51.6164 68.4509 51.4067 66.531 51.008 64.6765Z"
                fill="#F5F9FB"
            />
        </g>
        <path
            d="M51.008 64.6762H39.5938L33.5781 58.6606L32.1454 57.75H29.3954L28.4219 58.6606L22.4062 64.6762H10.9834C10.5847 66.5325 10.375 68.4541 10.375 70.4134V75.0317H51.6164V70.4083C51.6164 68.4506 51.4067 66.5308 51.008 64.6762Z"
            fill="#CB3434"
        />
        <g clipPath="url(#clip1_156787_129605)">
            <path
                d="M51.008 64.6765H39.5938C37.1942 62.2769 35.7219 59.7194 33.7527 57.7502L33.5781 43.2287C38.5259 41.4603 42.748 38.3397 45.8603 34.3526C47.213 32.6201 48.3559 30.7243 49.2583 28.7065C34.0181 28.4091 28.085 23.4677 10.9594 23.1738C12.8782 32.3638 19.4581 40.0147 28.4219 43.2217V58.6609L22.4062 64.6765H10.9834C10.5847 66.5327 10.375 68.4543 10.375 70.4137V75.032H51.6164V70.4085C51.6164 68.4509 51.4067 66.531 51.008 64.6765Z"
                fill="#EBF3F7"
            />
        </g>
        <path
            d="M51.6164 70.4089V75.0324H31V57.75H32.1467H32.375L39.5937 64.6769H51.008C51.4067 66.5314 51.6164 68.4513 51.6164 70.4089Z"
            fill="#F14C4B"
        />
        <path
            d="M5.21875 72.5312V83.7891H56.7641V72.5312H5.21875Z"
            fill="#6E5A8A"
        />
        <path d="M56.7727 72.5312V83.7891H31V72.5312H56.7727Z" fill="#58486E" />
        <path
            d="M0.0625 82.8438V88H61.9294C61.9294 88 61.9203 86.8457 61.9203 85.4219C61.9203 83.9981 61.9203 82.8438 61.9203 82.8438H0.0625Z"
            fill="#58486E"
        />
        <path
            d="M61.9375 85.4219V88H31V82.8438H61.9375V85.4219Z"
            fill="#4D3F61"
        />
        <path
            d="M5.21875 4.29688V15.5547H56.7641V4.29688H5.21875Z"
            fill="#6E5A8A"
        />
        <path d="M56.7727 4.29688V15.5547H31V4.29688H56.7727Z" fill="#58486E" />
        <path
            d="M0.0625 0V5.15625H61.9294C61.9294 5.15625 61.9203 4.00194 61.9203 2.57812C61.9203 1.15431 61.9203 0 61.9203 0H0.0625Z"
            fill="#58486E"
        />
        <path
            d="M61.9375 2.57812V5.15625H31V0H61.9375V2.57812Z"
            fill="#4D3F61"
        />
        <defs>
            <clipPath id="clip0_156787_129605">
                <rect
                    width="41.2414"
                    height="51.8581"
                    fill="white"
                    transform="translate(10.375 23.1738)"
                />
            </clipPath>
            <clipPath id="clip1_156787_129605">
                <rect
                    width="20.625"
                    height="52.25"
                    fill="white"
                    transform="translate(31 22)"
                />
            </clipPath>
        </defs>
    </Icon>
)

const Clock = props => (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
        <circle
            cx="12.5"
            cy="12"
            r="9"
            fill="#FCF1DA"
            stroke="#58486E"
            strokeWidth="2.07692"
        />
        <path
            d="M12.5 5.76929V12.6924L16 15.9998"
            stroke="#F0B847"
            strokeWidth="0.692308"
        />
    </Icon>
)

const Audio = props => {
    const { className, style, ...rest } = props
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            {...rest}
            className={`text-[#575757] ${className || ''}`}
            style={style}
        >
            <path
                d="M5.125 6.9375H2.125V11.4375H5.125L11.5 15.1875V2.8125L5.125 6.9375Z"
                stroke="currentColor"
                strokeWidth="3"
            />
            <path
                d="M14.5 6.1875L16.75 4.6875M14.875 8.8125H17.875M14.5 11.4375L16.75 12.9375"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    )
}

const Cross = props => (
    <Icon
        viewBox="0 0 16 16"
        fill="none"
        {...props}
        className={`${props.className || ''} dark:text-gray-300`}
        style={{ color: '#333333', ...props.style }}
    >
        <g clipPath="url(#clip0_156787_127253)">
            <path
                d="M2.95312 2L14.9531 14M14.9531 2L2.95312 14"
                stroke="currentColor"
                strokeWidth="3"
            />
        </g>
        <defs>
            <clipPath id="clip0_156787_127253">
                <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.953125)"
                />
            </clipPath>
        </defs>
    </Icon>
)

const Microphone = props => (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
        <path
            d="M8.0407 15.693L1.33594 19.6766L4.68832 25.2535L8.05816 23.2378L9.10862 22.6273L11.3931 21.27L8.0407 15.693Z"
            fill="#F3C66C"
        />
        <path
            d="M8.0407 15.693L1.33594 19.6766L4.68832 25.2535L8.05816 23.2378M8.0407 15.693L11.3931 21.27M8.0407 15.693L16.4217 4.53906L19.56 9.90911M11.3931 21.27L24.8026 18.8799L22.1813 14.3945M11.3931 21.27L9.10863 22.6273L8.05816 23.2378M11.1137 28.6664L8.05816 23.2378M19.56 9.90911L22.2883 9.31933L23.9645 11.7095L22.1813 14.3945M19.56 9.90911L22.1813 14.3945"
            stroke="#333333"
            strokeWidth="1.33333"
        />
        <path
            d="M23.9609 6.13339L24.8613 3.33398M26.4752 8.52352L30.6657 6.13339M26.4752 11.7104L29.8276 12.5071"
            stroke="#EF3837"
            strokeWidth="2"
        />
    </Icon>
)

const Dojo = props => (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
        <path
            d="M6.6499 8.77148L6.65732 11.0498L25.3499 11.0499V8.77148H6.6499Z"
            fill="currentColor"
        />
        <path
            d="M23.6998 11.05H21.4703V14.6298H23.6998V11.05ZM8.2998 27H10.5294V16.9078H8.2998V27ZM10.5294 11.05H8.2998V14.6298H10.5294V11.05Z"
            fill="currentColor"
        />
        <path
            d="M14.5943 6.54621H9.61417C7.31694 6.54621 5.43936 5.62791 4.49404 5.05698C4.20592 4.88296 3.84743 5.13234 3.90631 5.4696C4.02985 6.17547 4.2897 6.80687 4.57325 7.32752C5.08635 8.26953 6.05986 8.85 7.11291 8.85H24.8869C25.94 8.85 26.9135 8.26953 27.4266 7.32752C27.7101 6.80687 27.97 6.17547 28.0935 5.4696C28.1524 5.13234 27.7939 4.88296 27.5058 5.05698C26.5605 5.62791 24.6829 6.54621 22.3857 6.54621H17.4056"
            fill="currentColor"
        />
        <path
            d="M23.7 20.6534V17.1001H21.5V27.0001H23.7V23.4467"
            fill="currentColor"
        />
        <path
            d="M25.5015 14.5H6.50146V17.5H25.5015V14.5Z"
            fill="currentColor"
        />
    </Icon>
)

const Laptop = props => (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.39485 8.44531V22.2481H26.6156V8.44531H5.39485ZM5.85011 21.7062V8.95271H26.1056V21.7062H5.85011Z"
            fill="#333333"
        />
        <path
            d="M29.3386 25.6285H2.67188V26.0939H29.3386V25.6285Z"
            fill="#333333"
        />
        <path
            d="M5.85011 22.7963L4.1394 25.0643H27.8174L26.3054 22.7963H5.85011Z"
            fill="#333333"
        />
        <path
            d="M5.85011 8.95271V21.7062H26.1056V8.95271H5.85011Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.6156 22.2481H5.39485L2.67188 25.6285H29.3386L26.6156 22.2481ZM4.1394 25.0643L5.85011 22.7963H26.3054L27.8174 25.0643H4.1394Z"
            fill="white"
        />
        <path
            d="M5.39485 22.2481V8.44531H26.6156V22.2481M5.39485 22.2481H26.6156M5.39485 22.2481L2.67188 25.6285M26.6156 22.2481L29.3386 25.6285M2.67188 25.6285H29.3386M2.67188 25.6285V26.0939H29.3386V25.6285M5.85011 8.95271V21.7062H26.1056V8.95271H5.85011ZM5.85011 22.7963L4.1394 25.0643H27.8174L26.3054 22.7963H5.85011Z"
            stroke="#333333"
            strokeWidth="0.333333"
        />
        <path
            d="M6.0026 21.6673V9.00065H26.0026V21.6673H6.0026Z"
            stroke="#333333"
            strokeWidth="1.33333"
        />
        <path
            d="M16.6045 12.1953L14.9688 18.3002"
            stroke="#EF3837"
            strokeWidth="0.666667"
        />
        <path
            d="M17.5081 13.1855L19.5707 15.2482L17.5081 17.3108"
            stroke="#333333"
            strokeWidth="0.666667"
        />
        <path
            d="M14.0706 13.1855L12.0079 15.2482L14.0706 17.3108"
            stroke="#333333"
            strokeWidth="0.666667"
        />
    </Icon>
)

const Life = props => (
    <Icon viewBox="0 0 24 24" {...props}>
        <path
            d="M7.62821 3L2.5 6.97059V12.2647L12.5 21L22.5 12.2647V6.97059L17.6282 3L12.5 6.44118L7.62821 3Z"
            fill={props.borderColor}
            stroke={props.borderColor}
        />
        <path
            d="M6.62821 3L1.5 6.97059V12.2647L11.5 21L21.5 12.2647V6.97059L16.6282 3L11.5 6.44118L6.62821 3Z"
            fill={props.color}
            stroke={props.borderColor}
        />
    </Icon>
)

const Info = props => (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
        <path
            d="M5.5 5.5H26.5V26.5H5.5V5.5Z"
            stroke="currentColor"
            strokeWidth="3"
        />
        <path d="M16 22V13" stroke="currentColor" strokeWidth="3" />
        <path d="M16 12V9.5" stroke="currentColor" strokeWidth="3" />
    </Icon>
)

const BestStreakGreaterTen = props => (
    <Icon viewBox="0 0 16 16" fill="none" {...props}>
        <g clipPath="url(#clip0_156787_126929)">
            <rect
                x="8.29688"
                y="8.56934"
                width="7.02308"
                height="1.29816"
                fill="#F3C66C"
            />
            <rect
                x="8.3125"
                y="9.96582"
                width="7.09132"
                height="4.34682"
                fill="white"
            />
            <path
                d="M10.0853 8.49493H8.3125V14.3124H15.4038V8.49493H13.631M10.0853 8.49493V7.20215M10.0853 8.49493H13.631M13.631 8.49493V7.20215"
                stroke="#333333"
                strokeWidth="0.44442"
            />
            <path
                d="M8.3125 10.0029H15.4038"
                stroke="#333333"
                strokeWidth="0.44442"
            />
            <rect
                x="10.1719"
                y="12.126"
                width="0.818968"
                height="0.821159"
                fill="#EF3837"
            />
            <rect
                x="8.86719"
                y="10.7568"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="11.4531"
                y="12.1396"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="8.89062"
                y="12.1396"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="10.1719"
                y="10.7568"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="11.4531"
                y="10.7568"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="12.7344"
                y="10.7568"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="14.0078"
                y="10.7568"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <path
                d="M3.8228 6.88144C3.34159 6.63926 3.04202 6.12218 3.06729 5.55789L3.09002 5.05035L2.70191 5.37819C2.24851 5.76118 1.10826 6.83131 0.766588 8.56904C0.395683 10.4553 1.08182 12.578 2.73147 13.8464L2.73187 13.8467L2.74489 13.8567L2.7451 13.8568C3.91873 14.7528 5.51482 15.0564 6.97954 14.8028C7.75829 14.668 8.50672 14.3747 9.14084 13.9223C9.5211 13.6514 9.86244 13.3288 10.1552 12.9639C11.3755 11.444 11.4085 9.63034 11.1249 8.41452C10.8787 7.3591 10.2735 6.42973 9.50936 5.67648L9.50935 5.67648C8.56794 4.74862 7.93254 3.64934 7.53195 2.7773C7.33204 2.34212 7.1916 1.96569 7.10134 1.69882C7.05623 1.56543 7.02371 1.45957 7.00261 1.38761C6.99206 1.35163 6.98437 1.32414 6.97939 1.30593L6.97394 1.28569L6.97271 1.28098L6.97246 1.28002L6.97245 1.27999L6.97243 1.2799L6.97242 1.27988L6.91157 1.04155L6.68056 1.12637L6.75714 1.33496C6.68056 1.12637 6.6804 1.12642 6.68023 1.12649L6.67982 1.12664L6.6788 1.12702L6.67589 1.12811L6.66676 1.13166C6.65922 1.13463 6.64881 1.13883 6.63579 1.14434C6.60974 1.15536 6.57317 1.17163 6.52803 1.19373C6.43781 1.23789 6.31295 1.30555 6.16924 1.40149C5.88207 1.59318 5.51713 1.89947 5.20431 2.35888C4.58986 3.26126 4.20427 4.71225 4.91514 6.94828C4.67788 7.02148 4.24962 7.09621 3.8228 6.88144ZM3.8228 6.88144L3.72291 7.07993M3.8228 6.88144L3.72291 7.07993M3.72291 7.07993C3.24402 6.83892 2.92333 6.36769 2.85656 5.83279L6.55274 1.43055C5.88363 1.78535 3.87544 3.21182 5.19242 7.07993C5.11361 7.11745 4.42306 7.43224 3.72291 7.07993Z"
                fill="url(#paint0_radial_156787_126929)"
                stroke="#333333"
                strokeWidth="0.44442"
            />
            <path
                d="M4.42588 9.56813V9.12122L4.06955 9.39096C3.30684 9.96832 2.85855 10.8734 2.85855 11.8343C2.85855 13.5196 4.21297 14.8892 5.88803 14.8892C7.5631 14.8892 8.91752 13.5196 8.91752 11.8343C8.91752 11.0519 8.55233 10.3145 7.93113 9.84421C7.93112 9.8442 7.93111 9.8442 7.93111 9.84419L7.58808 9.58445L7.58803 9.58441C7.09196 9.20899 6.93208 8.52814 7.21005 7.96717L7.42418 7.53504L6.95657 7.65305C5.70175 7.96974 4.90288 9.17653 5.05263 10.436C4.69004 10.319 4.42588 9.97582 4.42588 9.56813Z"
                fill="#F4D44E"
                stroke="#333333"
                strokeWidth="0.44442"
            />
        </g>
        <defs>
            <radialGradient
                id="paint0_radial_156787_126929"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(5.77879 14.7013) rotate(-179.744) scale(7.62079 12.8683)"
            >
                <stop stopColor="#F0B847" />
                <stop offset="0.630208" stopColor="#F29100" />
                <stop offset="0.972" stopColor="#EF3837" />
            </radialGradient>
            <clipPath id="clip0_156787_126929">
                <rect
                    width="16"
                    height="15.9983"
                    fill="white"
                    transform="translate(0 0.000976562)"
                />
            </clipPath>
        </defs>
    </Icon>
)

const Bulb = props => (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
        <path
            d="M16.0025 8.70313C17.4409 8.70229 18.8372 9.16289 19.9647 10.0101C21.0922 10.8572 21.8846 12.0412 22.213 13.3696C22.5414 14.6979 22.3866 16.0926 21.7738 17.327C21.1609 18.5613 20.126 19.5628 18.8372 20.1687L18.8358 21.4695C18.8358 22.1823 18.8372 24.1572 18.8372 24.1572H16.0025H13.1692V21.4695V20.1687C11.8805 19.5629 10.8457 18.5615 10.2328 17.3273C9.61991 16.0931 9.46501 14.6985 9.79325 13.3702C10.1215 12.042 10.9136 10.858 12.0408 10.0107C13.1681 9.16341 14.5643 8.70259 16.0025 8.70313Z"
            fill="#F3C66C"
        />
        <path
            d="M13.1692 27.9997H18.8358M18.8372 24.1572C18.8372 24.1572 18.8358 22.1823 18.8358 21.4695L18.8372 20.1687C20.126 19.5628 21.1609 18.5613 21.7738 17.327C22.3866 16.0926 22.5414 14.6979 22.213 13.3696C21.8846 12.0412 21.0922 10.8572 19.9647 10.0101C18.8372 9.16289 17.4409 8.70229 16.0025 8.70313C14.5643 8.70259 13.1681 9.16341 12.0408 10.0107C10.9136 10.858 10.1215 12.042 9.79325 13.3702C9.46501 14.6985 9.61991 16.0931 10.2328 17.3273C10.8457 18.5615 11.8805 19.5629 13.1692 20.1687V21.4695M18.8372 24.1572C18.8372 24.1572 16.7539 24.1572 16.0025 24.1572M18.8372 24.1572H16.0025M16.0025 24.1572C15.251 24.1572 13.1692 24.1572 13.1692 24.1572M16.0025 24.1572H13.1692M13.1692 24.1572C13.1692 24.1572 13.1692 22.1823 13.1692 21.4695M13.1692 24.1572V21.4695"
            stroke="#333333"
            strokeWidth="1.33333"
            strokeLinecap="square"
        />
        <path
            d="M15.9974 5.34383V4M23.0807 8.0315L24.4974 6.68766M8.91406 8.0315L7.4974 6.68766M23.8776 20.4829L25.2942 21.8268M8.09501 20.4829L6.67834 21.8268M6.08073 13.4068H4.66406M27.3307 13.4068H25.9141"
            stroke="#EF3837"
            strokeWidth="1.33333"
            strokeLinecap="square"
        />
    </Icon>
)

const Thunder = props => (
    <Icon viewBox="0 0 6 12" {...props}>
        <mask id="path-1-inside-1_156787_126950" fill="white">
            <path d="M3.8608 0.0281323L0.00610312 7.14294C-0.012529 7.17732 0.0137495 7.21821 0.0544547 7.21821H2.43253C2.46465 7.21821 2.48978 7.24453 2.48664 7.27489L2.00445 11.9432C1.99856 12.0002 2.08023 12.0226 2.1072 11.9713L5.99419 4.58618C6.01226 4.55185 5.98598 4.51144 5.94556 4.51144H3.63039C3.59858 4.51144 3.57355 4.48561 3.5762 4.45549L3.96337 0.0560481C3.96829 -0.000267762 3.88805 -0.0221307 3.8608 0.0281323Z" />
        </mask>
        <path
            d="M0.00610312 7.14294L2.64368 8.57235L2.64385 8.57203L0.00610312 7.14294ZM2.48664 7.27489L5.47077 7.58313L5.47078 7.58303L2.48664 7.27489ZM2.00445 11.9432L-0.979671 11.6349L-0.97968 11.635L2.00445 11.9432ZM2.1072 11.9713L-0.547546 10.5741L-0.547769 10.5745L2.1072 11.9713ZM5.99419 4.58618L3.3395 3.18883L3.33945 3.18892L5.99419 4.58618ZM3.5762 4.45549L6.56465 4.71851L6.56465 4.71849L3.5762 4.45549ZM3.96337 0.0560481L6.95182 0.319045L6.95199 0.317109L3.96337 0.0560481ZM3.8608 0.0281323L1.2234 -1.40159L1.22306 -1.40096L3.8608 0.0281323ZM1.22306 -1.40096L-2.63164 5.71385L2.64385 8.57203L6.49855 1.45722L1.22306 -1.40096ZM-2.63147 5.71353C-3.85862 7.97789 -1.99166 10.2182 0.0544547 10.2182V4.21821C2.01916 4.21821 3.83356 6.37675 2.64368 8.57235L-2.63147 5.71353ZM0.0544547 10.2182H2.43253V4.21821H0.0544547V10.2182ZM2.43253 10.2182C0.857162 10.2182 -0.694199 8.87175 -0.49749 6.96675L5.47078 7.58303C5.67376 5.61731 4.07213 4.21821 2.43253 4.21821V10.2182ZM-0.49748 6.96666L-0.979671 11.6349L4.98858 12.2514L5.47077 7.58313L-0.49748 6.96666ZM-0.97968 11.635C-1.16504 13.43 0.13262 14.585 1.25107 14.8913C2.35693 15.1942 3.9689 14.8759 4.76216 13.3682L-0.547769 10.5745C0.21853 9.11797 1.77618 8.81416 2.83594 9.1044C3.90828 9.39809 5.16805 10.5133 4.98858 12.2513L-0.97968 11.635ZM4.76194 13.3686L8.64893 5.98345L3.33945 3.18892L-0.547546 10.5741L4.76194 13.3686ZM8.64888 5.98354C9.83847 3.72358 7.98075 1.51144 5.94556 1.51144V7.51144C3.99122 7.51144 2.18606 5.38013 3.3395 3.18883L8.64888 5.98354ZM5.94556 1.51144H3.63039V7.51144H5.94556V1.51144ZM3.63039 1.51144C5.19165 1.51144 6.73068 2.83202 6.56465 4.71851L0.587751 4.19248C0.416418 6.1392 2.00551 7.51144 3.63039 7.51144V1.51144ZM6.56465 4.71849L6.95182 0.319045L0.97492 -0.206949L0.58775 4.19249L6.56465 4.71849ZM6.95199 0.317109C7.10686 -1.45583 5.82412 -2.58974 4.71237 -2.89248C3.61224 -3.19205 2.02365 -2.87781 1.2234 -1.40158L6.49821 1.45785C5.7252 2.88382 4.19036 3.18385 3.13593 2.89672C2.06988 2.60643 0.824801 1.51161 0.97475 -0.205012L6.95199 0.317109Z"
            fill="#F29100"
            mask="url(#path-1-inside-1_156787_126950)"
        />
    </Icon>
)

const WorkoutMap = props => (
    <Icon height="20" viewBox="0 0 20 20" fill="none" {...props}>
        <rect y="15" width="5" height="5" fill="#949494" />
        <rect x="7.5" y="15" width="5" height="5" fill="#949494" />
        <rect x="7.5" y="7.5" width="5" height="5" fill="#9FB34E" />
        <rect x="7.5" width="5" height="5" fill="#4FAF54" />
        <rect x="15" y="15" width="5" height="5" fill="#949494" />
        <rect x="15" y="7.5" width="5" height="5" fill="#9FB34E" />
    </Icon>
)

const CurrentStreakLessNine = props => (
    <Icon viewBox="0 0 12 15" fill="none" {...props}>
        <path
            d="M4.11968 6.60507C3.63846 6.3629 3.3389 5.84581 3.36417 5.28152L3.3869 4.77398L2.99879 5.10182C2.54539 5.48482 1.40514 6.55494 1.06346 8.29268C0.692558 10.1789 1.37869 12.3016 3.02834 13.57L3.02874 13.5703L3.04177 13.5803L3.04197 13.5805C4.2156 14.4765 5.81169 14.78 7.27642 14.5264C8.05517 14.3916 8.8036 14.0984 9.43772 13.6459C9.81797 13.375 10.1593 13.0525 10.4521 12.6875C11.6723 11.1676 11.7054 9.35397 11.4217 8.13815C11.1755 7.08273 10.5704 6.15337 9.80623 5.40012L9.80623 5.40011C8.86481 4.47225 8.22941 3.37297 7.82883 2.50094C7.62892 2.06575 7.48847 1.68933 7.39822 1.42245C7.35311 1.28907 7.32059 1.18321 7.29949 1.11124C7.28894 1.07526 7.28125 1.04777 7.27627 1.02957L7.27082 1.00932L7.26958 1.00462L7.26933 1.00365L7.26932 1.00362L7.2693 1.00354L7.2693 1.00352L7.20844 0.765186L6.97744 0.849998L7.05402 1.05859C6.97744 0.849998 6.97727 0.850057 6.9771 0.85012L6.9767 0.85027L6.97567 0.850652L6.97277 0.851747L6.96363 0.855289C6.95609 0.858259 6.94569 0.862464 6.93266 0.867976C6.90662 0.878997 6.87005 0.895263 6.8249 0.917361C6.73469 0.961525 6.60982 1.02919 6.46611 1.12512C6.17894 1.31681 5.81401 1.6231 5.50119 2.08252C4.88673 2.9849 4.50114 4.43588 5.21201 6.67192C4.97476 6.74512 4.5465 6.81984 4.11968 6.60507ZM4.11968 6.60507L4.01978 6.80356M4.11968 6.60507L4.01978 6.80356M4.01978 6.80356C3.54089 6.56256 3.22021 6.09132 3.15344 5.55642L6.84962 1.15418C6.1805 1.50899 4.17232 2.93545 5.48929 6.80356C5.41049 6.84108 4.71993 7.15587 4.01978 6.80356Z"
            fill="url(#paint0_radial_156787_131497)"
            stroke="#333333"
            strokeWidth="0.44442"
        />
        <defs>
            <radialGradient
                id="paint0_radial_156787_131497"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(6.07566 14.425) rotate(-179.744) scale(7.62079 12.8683)"
            >
                <stop stopColor="#F0B847" />
                <stop offset="0.630208" stopColor="#F29100" />
                <stop offset="0.972" stopColor="#EF3837" />
            </radialGradient>
        </defs>
    </Icon>
)

const CurrentStreakGreaterTen = props => (
    <Icon viewBox="0 0 12 16" fill="none" {...props}>
        <path
            d="M3.8853 6.88046C3.40409 6.63829 3.10452 6.1212 3.12979 5.55691L3.15252 5.04937L2.76441 5.37721C2.31101 5.76021 1.17076 6.83033 0.829088 8.56807C0.458183 10.4543 1.14432 12.577 2.79397 13.8454L2.79437 13.8457L2.80739 13.8557L2.8076 13.8558C3.98123 14.7519 5.57732 15.0554 7.04204 14.8018C7.82079 14.667 8.56922 14.3738 9.20334 13.9213C9.5836 13.6504 9.92494 13.3279 10.2177 12.9629C11.438 11.443 11.471 9.62936 11.1874 8.41355C10.9412 7.35812 10.336 6.42876 9.57186 5.67551L9.57185 5.6755C8.63044 4.74764 7.99504 3.64836 7.59445 2.77633C7.39454 2.34114 7.2541 1.96472 7.16384 1.69784C7.11873 1.56446 7.08621 1.4586 7.06511 1.38663C7.05456 1.35065 7.04687 1.32316 7.04189 1.30496L7.03644 1.28472L7.03521 1.28001L7.03496 1.27904L7.03495 1.27901L7.03493 1.27893L7.03492 1.27891L6.97407 1.04058L6.74306 1.12539L6.81964 1.33398C6.74306 1.12539 6.7429 1.12545 6.74273 1.12551L6.74232 1.12566L6.7413 1.12604L6.73839 1.12714L6.72926 1.13068C6.72172 1.13365 6.71131 1.13786 6.69829 1.14337C6.67224 1.15439 6.63567 1.17065 6.59053 1.19275C6.50031 1.23692 6.37545 1.30458 6.23174 1.40051C5.94457 1.59221 5.57963 1.8985 5.26681 2.35791C4.65236 3.26029 4.26677 4.71127 4.97764 6.94731C4.74038 7.02051 4.31212 7.09523 3.8853 6.88046ZM3.8853 6.88046L3.78541 7.07895M3.8853 6.88046L3.78541 7.07895M3.78541 7.07895C3.30652 6.83795 2.98583 6.36671 2.91906 5.83181L6.61524 1.42957C5.94613 1.78438 3.93794 3.21084 5.25492 7.07895C5.17611 7.11647 4.48556 7.43126 3.78541 7.07895Z"
            fill="url(#paint0_radial_157156_1458)"
            stroke="#333333"
            strokeWidth="0.44442"
        />
        <path
            d="M7.90742 10.0142L7.90742 10.0142C8.30713 10.4082 8.62807 10.8985 8.75912 11.4603M7.90742 10.0142L8.54272 11.5108M7.90742 10.0142C7.44095 9.55443 7.12434 9.00769 6.92382 8.57116C6.82394 8.35374 6.75384 8.16581 6.70892 8.03299C6.68648 7.96663 6.67038 7.91419 6.66003 7.87889C6.65485 7.86125 6.65112 7.8479 6.64875 7.83925L6.64622 7.82986L6.64571 7.82791L6.64569 7.82784L6.64567 7.82774L6.64565 7.82768L6.64564 7.82764L6.58481 7.5894L6.35381 7.67422L6.43039 7.88281M7.90742 10.0142L6.43039 7.88281M8.75912 11.4603L8.54272 11.5108M8.75912 11.4603C8.75912 11.4603 8.75912 11.4603 8.75912 11.4603L8.54272 11.5108M8.75912 11.4603C8.90843 12.1003 8.89277 13.0609 8.24459 13.8683M8.54272 11.5108C8.6819 12.1074 8.66388 12.9911 8.07126 13.7292M8.24459 13.8683L8.07126 13.7292M8.24459 13.8683C8.08936 14.0618 7.90839 14.2328 7.70675 14.3765M8.24459 13.8683C8.24457 13.8683 8.24455 13.8683 8.24454 13.8684L8.07126 13.7292M8.07126 13.7292L7.70675 14.3765M7.70675 14.3765L7.57768 14.1956L7.70663 14.3766C7.70667 14.3765 7.70671 14.3765 7.70675 14.3765ZM7.70675 14.3765C7.36931 14.6172 6.97276 14.7722 6.56217 14.8432C5.79164 14.9766 4.94759 14.8182 4.3227 14.3411M7.70675 14.3765L4.3227 14.3411M6.43039 7.88281C6.35381 7.67422 6.35365 7.67427 6.35349 7.67433L6.35314 7.67446L6.35232 7.67477L6.35025 7.67555L6.34439 7.67782L6.32611 7.68531C6.31113 7.69164 6.2907 7.70074 6.26582 7.71292C6.21613 7.73725 6.14831 7.77404 6.07065 7.82589C5.91557 7.9294 5.71876 8.09461 5.55004 8.34239C5.22631 8.81782 5.03202 9.55776 5.35466 10.6594C5.25149 10.6754 5.11793 10.6737 4.98636 10.6075L6.43039 7.88281ZM4.68464 9.52892L4.66191 10.0365C4.6509 10.2823 4.78139 10.5044 4.98635 10.6075L4.68464 9.52892ZM4.68464 9.52892L4.29653 9.85676M4.68464 9.52892L4.29653 9.85676M4.29653 9.85676C4.05933 10.0571 3.45615 10.6219 3.27511 11.5427C3.07894 12.5403 3.44102 13.6632 4.31547 14.3356L4.31587 14.3359M4.29653 9.85676L4.31587 14.3359M4.31587 14.3359L4.32249 14.3409L4.3227 14.3411M4.31587 14.3359L4.3227 14.3411"
            fill="#F4D44E"
            stroke="#333333"
            strokeWidth="0.44442"
        />
        <defs>
            <radialGradient
                id="paint0_radial_157156_1458"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(5.84129 14.7004) rotate(-179.744) scale(7.62079 12.8683)"
            >
                <stop stopColor="#F0B847" />
                <stop offset="0.630208" stopColor="#F29100" />
                <stop offset="0.972" stopColor="#EF3837" />
            </radialGradient>
        </defs>
    </Icon>
)

const BestStreakLessNine = props => (
    <Icon viewBox="0 0 17 16" fill="none" {...props}>
        <g clipPath="url(#clip0_156787_126733)">
            <rect
                x="9.14062"
                y="8.56836"
                width="7.02308"
                height="1.29816"
                fill="#F3C66C"
            />
            <rect
                x="9.15625"
                y="9.96484"
                width="7.09132"
                height="4.34682"
                fill="white"
            />
            <path
                d="M10.9291 8.49395H9.15625V14.3115H16.2476V8.49395H14.4747M10.9291 8.49395V7.20117M10.9291 8.49395H14.4747M14.4747 8.49395V7.20117"
                stroke="#333333"
                strokeWidth="0.44442"
            />
            <path
                d="M9.15625 10.002H16.2476"
                stroke="#333333"
                strokeWidth="0.44442"
            />
            <rect
                x="11.0156"
                y="12.125"
                width="0.818968"
                height="0.821159"
                fill="#EF3837"
            />
            <rect
                x="9.71094"
                y="10.7559"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="12.2969"
                y="12.1387"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="9.73438"
                y="12.1387"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="11.0156"
                y="10.7559"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="12.2969"
                y="10.7559"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="13.5781"
                y="10.7559"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <rect
                x="14.8516"
                y="10.7559"
                width="0.818968"
                height="0.821159"
                fill="#333333"
            />
            <path
                d="M4.66655 6.88046C4.18534 6.63829 3.88577 6.1212 3.91104 5.55691L3.93377 5.04937L3.54566 5.37721C3.09226 5.76021 1.95201 6.83033 1.61034 8.56807C1.23943 10.4543 1.92557 12.577 3.57522 13.8454L3.57562 13.8457L3.58864 13.8557L3.58885 13.8558C4.76248 14.7519 6.35857 15.0554 7.82329 14.8018C8.60204 14.667 9.35047 14.3738 9.98459 13.9213C10.3648 13.6504 10.7062 13.3279 10.999 12.9629C12.2192 11.443 12.2523 9.62936 11.9686 8.41355C11.7224 7.35812 11.1173 6.42876 10.3531 5.67551L10.3531 5.6755C9.41169 4.74764 8.77629 3.64836 8.3757 2.77633C8.17579 2.34114 8.03535 1.96472 7.94509 1.69784C7.89998 1.56446 7.86746 1.4586 7.84636 1.38663C7.83581 1.35065 7.82812 1.32316 7.82314 1.30496L7.81769 1.28472L7.81646 1.28001L7.81621 1.27904L7.8162 1.27901L7.81618 1.27893L7.81617 1.27891L7.75532 1.04058L7.52431 1.12539L7.60089 1.33398C7.52431 1.12539 7.52415 1.12545 7.52398 1.12551L7.52357 1.12566L7.52255 1.12604L7.51964 1.12714L7.51051 1.13068C7.50297 1.13365 7.49256 1.13786 7.47954 1.14337C7.45349 1.15439 7.41692 1.17065 7.37178 1.19275C7.28156 1.23692 7.1567 1.30458 7.01299 1.40051C6.72582 1.59221 6.36088 1.8985 6.04806 2.35791C5.43361 3.26029 5.04802 4.71127 5.75889 6.94731C5.52163 7.02051 5.09337 7.09523 4.66655 6.88046ZM4.66655 6.88046L4.56666 7.07895M4.66655 6.88046L4.56666 7.07895M4.56666 7.07895C4.08777 6.83795 3.76708 6.36671 3.70031 5.83181L7.39649 1.42957C6.72738 1.78438 4.71919 3.21084 6.03617 7.07895C5.95736 7.11647 5.26681 7.43126 4.56666 7.07895Z"
                fill="url(#paint0_radial_156787_126733)"
                stroke="#333333"
                strokeWidth="0.44442"
            />
        </g>
        <defs>
            <radialGradient
                id="paint0_radial_156787_126733"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(6.62254 14.7004) rotate(-179.744) scale(7.62079 12.8683)"
            >
                <stop stopColor="#F0B847" />
                <stop offset="0.630208" stopColor="#F29100" />
                <stop offset="0.972" stopColor="#EF3837" />
            </radialGradient>
            <clipPath id="clip0_156787_126733">
                <rect
                    width="16"
                    height="15.9983"
                    fill="white"
                    transform="translate(0.84375)"
                />
            </clipPath>
        </defs>
    </Icon>
)

const Tick = props => (
    <Icon viewBox="0 0 17 16" fill="none" {...props}>
        <g clipPath="url(#clip0_156787_127206)">
            <path
                d="M2.95312 7.81206L7.0765 12L14.9531 4"
                stroke="#4FAF54"
                strokeWidth="3"
            />
        </g>
        <defs>
            <clipPath id="clip0_156787_127206">
                <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.953125)"
                />
            </clipPath>
        </defs>
    </Icon>
)

const Mute = props => {
    const { className, style, ...rest } = props
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            {...rest}
            className={`text-[#575757] ${className || ''}`}
            style={style}
        >
            <path
                d="M5.125 6.9375H2.125V11.4375H5.125L11.5 15.1875V2.8125L5.125 6.9375Z"
                stroke="currentColor"
                strokeWidth="3"
            />
            <g clipPath="url(#clip0_156787_131491)">
                <path
                    d="M13.9375 7.125L17.3125 10.5M17.3125 7.125L13.9375 10.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_156787_131491">
                    <rect
                        width="4.5"
                        height="4.5"
                        fill="white"
                        transform="translate(13.375 6.5625)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

const ChallengeClearedIcon = props => (
    <Icon viewBox="0 0 96 96" fill="none" {...props}>
        <rect
            x="15.9141"
            y="20.5801"
            width="58.44"
            height="58.44"
            rx="29.22"
            fill="white"
            stroke="#333333"
            strokeWidth="3"
        />
        <path
            d="M29.1225 38.249L46.2586 52.1794L47.3262 53.0473L48.2829 52.0585L80.0844 19.1881V37.2583L47.2404 68.061L25.947 46.685L29.1225 38.249Z"
            fill="#4FAF54"
            stroke="#333333"
            strokeWidth="3"
        />
    </Icon>
)

export {
    Audio,
    BestStreakGreaterTen,
    BestStreakLessNine,
    Bulb,
    ChallengeClearedIcon,
    CheckMark,
    Clock,
    Cross,
    CurrentStreakGreaterTen,
    CurrentStreakLessNine,
    Divider,
    Dojo,
    HourGlassRed,
    Info,
    Laptop,
    Life,
    Microphone,
    Mute,
    SrBrownBelt,
    SrRedBelt,
    Thunder,
    Tick,
    WorkoutMap,
}
